/* eslint-disable camelcase */
import React from 'react';
import TreeView from '../../GroupTreeView/GroupTreeView';
import { ModuleSectionDocumentType, ITabParams } from '../../../config/types';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../redux/store';
import { openModuleSectionsTab } from './ModuleSectionsUtils';
import { triggerEvent } from '../../../redux/event';
import {
  fetchModuleSectionGroups,
  fetchModuleSections
} from '../../../redux/moduleSection';
import { setSelectedNode } from '../../../redux/activeNode';
import {
  builderPageTypes as BPT,
  builderPageTypes
} from '../../../config/constants/builderPageTypes';
import { ModuleSectionCollection } from '@digitalworkflow/dwtranslateclient';
import { updateDataEverywhere } from '../../../utils';
import { ITreeViewData } from '@digitalworkflow/dwtranslateclient/lib/Models/Module/ModuleCollection';
import styles from '../Renderers.module.scss';

export const GroupsModuleSections = ({
  ref,
  type,
  selectedRows,
  gridReferences,
  setCurrentEventAPI,
  setSelectedRowIndex,
  setSelectedRows,
  fetchData,
  setRowSelectedFlag,
  setTabsRef,
  updateData
}: ITabParams) => {
  // const modules: ITreeViewData[] = useSelector(
  //   (state: RootState) => state.module.modules
  // );
  const groups: ITreeViewData[] = useSelector(
    (state: RootState) => state.moduleSection.groups
  );
  const moduleSections: any = useSelector(
    (state: RootState) => state.moduleSection.moduleSections
  );
  const dispatch = useAppDispatch();

  function reduxUpdater() {
    dispatch(fetchModuleSections());
    dispatch(fetchModuleSectionGroups());
  }

  function openForm() {
    dispatch(triggerEvent('showModalEvent'));
  }

  /**
   * callback to handle when a group is clicked in tree view
   * @param title string name of the group clicked
   */
  function handleGroupClick(title: string) {
    let moduleSectionFound = false;
    const rows: Partial<ModuleSectionDocumentType>[] = [];

    moduleSections.forEach((modSection: any) => {
      if (modSection._data.section_name === title) {
        console.log('module section found: ', modSection);
        moduleSectionFound = true;
        rows.push(modSection._data);
      }
    });

    if (!moduleSectionFound) return;

    console.log('modSection rows: ', rows);

    const tabId = title + '_tab';

    const tabAlreadyPresent = ref?.find(tabId);

    tabAlreadyPresent
      ? ref?.updateTab(tabId, null)
      : openModuleSectionsTab({
          ref,
          title,
          rows,
          firstTab: false,
          type,
          selectedRows,
          gridReferences,
          fetchData,
          setSelectedRows,
          setSelectedRowIndex,
          setCurrentEventAPI,
          setRowSelectedFlag,
          setTabsRef,
          updateData,
          updateMetaData: (data) => {
            updateDataEverywhere(
              ref,
              data.id,
              data,
              builderPageTypes.moduleSections,
              reduxUpdater
            );
          }
        });

    dispatch(setSelectedNode(title));
  }

  async function handleDrop(newData: ITreeViewData[]) {
    for (let index = 0; index < newData.length; index++) {
      if (newData[index].parent !== groups[index].parent) {
        const parentIndex = newData.findIndex(
          (v) => v.id === newData[index].parent
        );
        await ModuleSectionCollection.updateModuleSectionModule(
          newData[index].text as string,
          newData[parentIndex].text as string
        );
        dispatch(fetchModuleSectionGroups());
        break;
      }
    }
  }

  return (
    <div id={styles.treeView} className='overflow-y-auto h-100'>
      <TreeView
        pageType={BPT.moduleSections}
        data={groups}
        setShowModal={() => openForm()}
        handleGroupClick={(title) => handleGroupClick(title)}
        handleDrop={(newTreeData: ITreeViewData[]) => handleDrop(newTreeData)}
        tabRef={ref}
      />
    </div>
  );
};

export const HistoryModuleSections = () => {
  return (
    <div>
      <span>History available in V2</span>
    </div>
  );
};
